import { isDesktop } from './deviceType';

/**
 * Make call to segment with event name and payload
 * @param {String} event - name of the event to track
 * @param {Object} payload - event payload
 */
export const track = (event, payload) => {
  const { 3: orderUuid } = window.location.pathname.split('/');
  const deviceType = isDesktop() ? 'DESKTOP' : 'MOBILE';

  window.analytics.track(
    event,
    { ...payload },
    {
      context: {
        ip: '0.0.0.0',
      },
      deviceType,
      orderUuid,
      origin: 'MGO',
    },
  );
};
